import { render, staticRenderFns } from "./fullReports.vue?vue&type=template&id=dc6d4508&scoped=true"
import script from "./fullReports.vue?vue&type=script&lang=js"
export * from "./fullReports.vue?vue&type=script&lang=js"
import style0 from "./fullReports.vue?vue&type=style&index=0&id=dc6d4508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6d4508",
  null
  
)

export default component.exports